//
import ProviderAccountBanksModel from '@/models/Purchase/PchProviderAccountBank'

/**
 * This class describes provider account banks.
 * @class ProviderAccountBanks (name)
 */
export default class ProviderAccountBanks extends ProviderAccountBanksModel {

  /**
   * Returns a list service.
   * @return {<type>}.
   */
  static toList() {

    // 
    this.includes = [
      'g_bank',
      'g_type_account_bank',
      'pch_provider',
    ]
    
    //
    return this
  }
}
